import React, { ReactNode } from 'react';
import { useGuide } from './useGuide';
import { GuideTooltip } from './GuideTooltip';
import { TooltipPosition } from './types';

interface GuideStepProps {
  stepId: string;
  children: ReactNode;
  position?: TooltipPosition;
  className?: string;
}

export const GuideStep: React.FC<GuideStepProps> = ({
  stepId,
  children,
  position = 'top',
  className,
}) => {
  const { isCurrentStep } = useGuide();
  const isActive = isCurrentStep(stepId);

  return (
    <div style={{ position: 'relative' }} className={className}>
      {children}
      {isActive && <GuideTooltip position={position} />}
    </div>
  );
};
